// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1xzwN","left":"InfoRow_left__mahlM"};